import allSettled from 'promise.allsettled';

allSettled.shim();
